<div tabindex="-1">
    <button (click)="openBuyBookModal()" class="btn-buy-store" data-bs-placement="left" data-bs-toggle="tooltip" title="Buchkaufen">
        <span class="visually-hidden">Buch kaufen</span><i class="fa fa-shopping-cart"></i>
    </button>
</div>
